import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_SELLER_UPCOMING_CATALOGS_FAIL = 'la/domain/sellerUpcomingCatalogs/LOAD_FAIL';
export const LOAD_SELLER_UPCOMING_CATALOGS_REQUEST = 'la/domain/sellerUpcomingCatalogs/LOAD_REQUEST';
export const LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS = 'la/domain/sellerUpcomingCatalogs/LOAD_SUCCESS';
export type LoadSellerUpcomingCatalogsSuccessAction = TypedActionWithPayload<
    typeof LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS,
    any
>;
